const styles = `:host {
  align-items: center;
  display: inline-flex;
}
:host .goto-presence-indicator {
  box-sizing: border-box;
  --goto-icon-size: 10px;
  background-color: var(--goto-presence-indicator-avatar-color, transparent);
  border-radius: 50%;
  font-size: 10px;
  height: 10px;
  width: 10px;
}
:host .goto-presence-indicator--available {
  --goto-icon-color: var(--goto-presence-available);
}
:host .goto-presence-indicator--busy {
  --goto-icon-color: var(--goto-presence-busy);
}
:host .goto-presence-indicator--away {
  --goto-icon-color: var(--goto-presence-away);
}
:host .goto-presence-indicator--dnd {
  --goto-icon-color: var(--goto-presence-dnd);
}
:host .goto-presence-indicator--offline {
  --goto-icon-color: var(--goto-presence-offline);
}
:host .goto-presence-indicator--achromatic {
  --goto-icon-color: var(--goto-text-06);
}`; export default styles;